// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * TerriSTORY®
 *
 © Copyright 2022 AURA-EE
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * A copy of the GNU Affero General Public License should be present along
 * with this program at the root of current repository. If not, see
 * http://www.gnu.org/licenses/.
 */

.zone-select {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    font-size: 16px;
}

.zone-select label {
    margin-right: 8px;
    text-align: right;
}
.zone-select select {
    height: 32px;
    width: 120px;
    background: var(--col-gray-bg);
    border: solid 1px var(--col-gray-border);
    border-radius: 4px;
}
.zone-select .react-select__control {
    margin: 0 4px;
    min-height: 0;
    height: 32px;
    width: 200px;
    background: var(--col-gray-bg);
    border: solid 1px var(--col-gray-border);
    border-radius: 4px;
}
.zone-select .react-select__indicator {
    padding: 2px;
}
.zone-select .react-select__placeholder {
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
}

.main-zone-select-container {
    /* This container element is only used to center the .main-zone-select element */
    position: absolute;
    top: 60px;
    width: 100%;
    display: flex;
    justify-content: center;
    padding-left: 50px; /* Left toolbar width */
    pointer-events: none;
}
.main-zone-select {
    position: relative;
    padding: 1rem;
    z-index: 90;
    background: #fff;
    border: 1px solid #ccc;
    box-shadow: 4px 4px 4px rgba(100, 100, 100, 0.2);
    border-radius: 0px 0px 10px 10px;
    pointer-events: all;
}

.auto-complete-zone {
    margin-left: 5px;
}

.auto-complete-zone.shrink-hide {
    margin-left: 0px;
}
.auto-complete-zone.shrink-hide input {
    width: 0px;
    visibility: hidden;
}
.auto-complete-zone input {
    transition: width 0.1s ease;
}
`, "",{"version":3,"sources":["webpack://./src/style/doubleSelect.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;EAkBE;;AAEF;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,wCAAwC;IACxC,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,wCAAwC;IACxC,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gFAAgF;IAChF,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,kBAAkB,EAAE,uBAAuB;IAC3C,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,gDAAgD;IAChD,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,2BAA2B;AAC/B","sourcesContent":["/*\n * TerriSTORY®\n *\n © Copyright 2022 AURA-EE\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as published by\n * the Free Software Foundation, either version 3 of the License, or\n * (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the\n * GNU Affero General Public License for more details.\n *\n * A copy of the GNU Affero General Public License should be present along\n * with this program at the root of current repository. If not, see\n * http://www.gnu.org/licenses/.\n */\n\n.zone-select {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    font-size: 16px;\n}\n\n.zone-select label {\n    margin-right: 8px;\n    text-align: right;\n}\n.zone-select select {\n    height: 32px;\n    width: 120px;\n    background: var(--col-gray-bg);\n    border: solid 1px var(--col-gray-border);\n    border-radius: 4px;\n}\n.zone-select .react-select__control {\n    margin: 0 4px;\n    min-height: 0;\n    height: 32px;\n    width: 200px;\n    background: var(--col-gray-bg);\n    border: solid 1px var(--col-gray-border);\n    border-radius: 4px;\n}\n.zone-select .react-select__indicator {\n    padding: 2px;\n}\n.zone-select .react-select__placeholder {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 100%;\n}\n\n.main-zone-select-container {\n    /* This container element is only used to center the .main-zone-select element */\n    position: absolute;\n    top: 60px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    padding-left: 50px; /* Left toolbar width */\n    pointer-events: none;\n}\n.main-zone-select {\n    position: relative;\n    padding: 1rem;\n    z-index: 90;\n    background: #fff;\n    border: 1px solid #ccc;\n    box-shadow: 4px 4px 4px rgba(100, 100, 100, 0.2);\n    border-radius: 0px 0px 10px 10px;\n    pointer-events: all;\n}\n\n.auto-complete-zone {\n    margin-left: 5px;\n}\n\n.auto-complete-zone.shrink-hide {\n    margin-left: 0px;\n}\n.auto-complete-zone.shrink-hide input {\n    width: 0px;\n    visibility: hidden;\n}\n.auto-complete-zone input {\n    transition: width 0.1s ease;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
